import cn from 'classnames'
import { FC } from 'react'

import { GoogleIcon } from 'components/Images/Icons'

import styles from './GoogleButton.module.scss'

interface IProps {
  onClick?: () => void
  buttonText?: string
  loading?: boolean
  disabled?: boolean
  id?: string
}
const GoogleButton: FC<IProps> = ({ onClick, buttonText, loading, disabled, id }) => {
  return (
    <button
      id={id}
      onClick={onClick}
      className={cn(styles.oauth_button, styles.wave, {
        [styles.waveHidden]: !loading,
      })}
      disabled={disabled}
      color="background-70"
    >
      <GoogleIcon />
      {buttonText}
    </button>
  )
}

export default GoogleButton
